


















































import Vue from 'vue';
import DestintionDetailsCard from '@common/card/dest-details-card.vue';
import TagsRow from '@common/filter-tag/tags-row.vue';
import {FilterTag} from '@/views/amex/app-types';
import {
  DestinationDetailsCardInfo,
  disableAndSortNotMatchedTags,
  getFilterCardsFunction,
  FILTER_MODE,
} from './dest-details-helper';

const EMPTY_CARD = {
  id: '',
  title: '',
  images: [],
  isLoading: true,
};

const getEmptyCard = (id: string): DestinationDetailsCardInfo => ({...EMPTY_CARD, id} as DestinationDetailsCardInfo);

export default Vue.extend({
  components: {
    DestintionDetailsCard,
    TagsRow,
  },
  name: 'DestinationDetailsRow',
  props: {
    title: String,
    category: String,
    cards: Array,
    tags: Array,
    exploreAllLink: String,
    isLoading: Boolean,
    cardsFilterMode: {
      type: String,
      default: () => FILTER_MODE.BY_ANY_OF_TAGS,
    },
    showMatchedTags: {
      type: Boolean,
      default: () => false,
    },
    showMatchAndPrice: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      localTagsList: (this.tags as FilterTag[]) || ([] as FilterTag[]),
    };
  },
  watch: {
    tags: {
      handler: function(newVal: FilterTag[]) {
        this.localTagsList = newVal;
      },
      immediate: true,
    },
  },
  computed: {
    tagsList(): FilterTag[] {
      return this.localTagsList as FilterTag[];
    },

    sortedTags(): FilterTag[] {
      return disableAndSortNotMatchedTags(
        this.localTagsList as FilterTag[],
        this.cards as DestinationDetailsCardInfo[],
      );
    },

    selectedTags(): FilterTag[] {
      return (this.sortedTags as FilterTag[]).filter((tag) => tag.value);
    },

    cardsList(): DestinationDetailsCardInfo[] {
      return this.isLoading
        ? [getEmptyCard('w'), getEmptyCard('x'), getEmptyCard('y'), getEmptyCard('z')]
        : (this.cards as DestinationDetailsCardInfo[]);
    },

    cardsFilteredByTags(): DestinationDetailsCardInfo[] {
      const filterFunction = getFilterCardsFunction(this.cardsFilterMode as FILTER_MODE);

      const filteredCards = this.selectedTags.length
        ? filterFunction(this.cardsList, this.selectedTags)
        : this.cardsList;

      return filteredCards.slice(0, 4);
    },
  },
  methods: {
    cardMatchedTags(card: DestinationDetailsCardInfo): string[] {
      const cardTags = card.tags || [];
      const localTagsNames = this.localTagsList.map((tag) => tag.name);

      const matchedTags = cardTags.filter((tag) => localTagsNames.includes(tag));
      return matchedTags;
    },

    onToggleTag(toggledTags: FilterTag[]): void {
      const toggledTag = toggledTags[0];
      if (!toggledTag) {
        return;
      }

      const tagInList = (this.tagsList as FilterTag[]).find((tag) => tag.id === toggledTag.id);

      if (!tagInList) {
        return;
      }

      (tagInList as FilterTag).value = toggledTag.value;
    },

    onAddPreferences() {
      this.$emit('add-preferences-click', this.category);
    },
  },
});
